<style lang="less">


</style>
<template>
    <div class="container multi-form">
        <BaseLoading v-if="loading"></BaseLoading>
        <div class="flex-wrap flex-center container" v-if="error">{{ error }}</div>

        <Draggable
          v-if="!loading && !error"
          v-model="items"
          :animation="500"
          @input="emitChange"
        >
          <template v-for="(item,index) in items">
            <div :key="'tab'+index" style="border:1px solid var(--border);padding:10px;margin-bottom:10px;padding-top:30px;position:relative;">
                <div style="margin-bottom:10px;color:var(--subtext2)" v-if="cloneValues && !config.cloneKey">{{cloneValues[index]}}</div>
                <div class="flex-wrap flex-center" style="position:absolute;left:10px;top:10px;color:var(--subtext2);background:var(--border);border:1px solid var(--subtext2);width:20px;border-radius:3px;height:20px;">{{ index+1 }}</div>
            <UgoForm
                v-if="!loading && !error"
                :form="formDef"
                ref="form"
                :value="item"
                :editable="editable"
                style="background:none"
                :old="Array.isArray(old) ? old.find(v=>v.id == item.id):null"
                :design="design"
                :acl="config.acl"
                @input="handleChangeForm(index,$event)"
            />
                <BaseIcon icon="md-copy" v-if="!is_cloned " style="position:absolute;right:30px;top:10px;" @click="copy(index)" />
                <BaseIcon icon="md-trash" v-if="!is_cloned" style="position:absolute;right:10px;top:10px;" @click="remove(index)" />
            </div>

          </template>
        </Draggable>
        <template v-if="!error && !is_cloned">
        <BaseEmpty v-if="items.length == 0" image style="padding:20px;">
          <div class="flex-wrap flex-center" style="margin-bottom:20px" >
           <Button icon="md-add" size="small" @click="add">新增一行</Button>
          </div>
        </BaseEmpty>
        <div v-else class="flex-wrap flex-between" style="margin:5px 10px">
          <Alert v-if="error" type="error" size="small" style="padding:3px 5px">{{error}}</Alert>
          <div class="flex-wrap"  style="margin-bottom:20px;margin-top:5px;">

            <Button icon="md-add" size="small" @click="add">新增一行</Button>
            <slot name="button"></slot>
          </div>
        </div>
    </template>
    <div v-if="is_cloned && design" style="margin-top:10px;color:var(--subtext2);text-align:right">本表按照<span style="color:var(--error);margin:0 3px;">{{ config.cloneBy }}</span>进行克隆</div>
    </div>
  </template>
<script>

import Draggable from 'vuedraggable';
import {cloneDeep, debounce} from 'lodash';
import UgoForm from '../index.vue';
function evil(fn, params) {
  params.fix = (total, items, key, index)=>{
    return formatNumber(total - formatNumber(items.filter((v, i)=>i!=index).reduce((acc, item)=>{
      return acc + item[key];
    }, 0)));
  };
  const Fn = Function; // 一个变量指向Function，防止有些前端编译工具报错
  return new Fn('params', 'console.log(params);console.log('+fn+');return ' + fn)(params);
}
function formatNumber(e) {
  if (isNaN(e)) {
    return 0;
  } else {
    return parseInt(e*100)/100;
  }
}
import defaultValueMixin from '../mixins/default-value';
export default {
  mixins: [defaultValueMixin],
  cname: '多重表',
  corder: 82,
  components: {Draggable, UgoForm},
  data() {
    return {
      items: [{}],
      vid: 0,
      formDef: {},
      error: '请选择数据模型(model)',
      loading: false,
    };
  },
  created() {
    this.vid = parseInt(Math.random()*10000);
  },
  computed: {
    is_cloned() {
      return this.config.cloneKey;
    },
    cloneValues() {
      if (this.is_cloned && this.model && this.config.cloneBy) {
        let values = this.model;
        if (this.config.cloneBy) {
          this.config.cloneBy.split('.').forEach((v)=>{
            if (values) {
              values = values[v];
            }
          });
        } else {
          return null;
        }
        return values;
      } else {
        return null;
      }
    },
  },
  props: {
    design: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Object,
    },
    fields: {
      type: Array,
      default: ()=>([]),
    },
    label: {
      type: String,
    },
    model: {
      type: Object,
      default: ()=>({}),
    },
    old: {
    },
    value: {
      type: Object | Array,
      default: () => ({}),
    },
    editable: {
      type: Boolean,
    },
    config: {
      type: Object,
      default: ()=>({}),
    },

  },
  watch: {
    'config.model': {
      handler(v) {
        if (this.design) {
          return;
        }
        if (v) {
          this.getRemoteData();
        } else {
          this.error='请选择数据模型';
        }
      },
      deep: true,

    },
    'cloneValues': {

      handler(v, old) {
        if (this.design) {
          return;
        }
        if (this.is_cloned) {
          this.initValue();
        }
      },
      deep: true,
      immediate: true,
    },
    'value': {
      handler(v) {
        if (!Array.isArray(v)) {
          this.initValue();
        } else {
          this.items = cloneDeep(v);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    if (this.config &&this.config.model) {
      this.getRemoteData();
    }
  },
  properties: [
    {
      label: '数据模型',
      key: 'model',
      control: 'Select',
      option: {
        valueKey: 'key',
        getters: 'session/models',
      },
    },
    {
      label: '克隆',
      key: 'cloneBy',
      control: 'Text',
    }, {
      label: '克隆key',
      key: 'cloneKey',
      control: 'Text',
    },
    {
      label: '可见性',
      key: 'acl',
      control: 'PermissionSelect',
    },

  ],
  initModel(obj) {
    obj.config = {

    };
    return obj;
  },
  methods: {
    getUpdateData(e) {
      const updateData = {
        empty: true,
      };
      console.log(this.$refs.form,this.old,this.value)
      let forms = this.$refs.form
      if(!forms)
        return {empty:true}
      if(!Array.isArray(forms))
        forms = [forms]
      if (forms.length > 0) {
        const val = forms.map((f)=>f.getUpdateData()).filter((v)=>v);
        console.log(val)
        updateData.toUpdate = val.filter((v)=>v.id);
        updateData.toCreate = val.filter((v)=>!v.id);
        updateData.toDelete = this.old.filter((v)=>val.find((t)=>t.id == v.id)==null).map((v)=>v.id);
      } else {
        if ( Array.isArray(this.old) && this.old.length !== 0) {
          updateData.toDelete = this.old.map((v)=>v.id);
          updateData.empty = false;
        }
      }
      if (!updateData.empty) {
        return updateData;
      }
    },
    validate() {
      console.log('m-validate');
      const valid = true;
      if (Array.isArray(this.$refs.form) && Array.isArray(this.$refs.form).length > 0) {
        for (let i=0; i<this.$refs.form.length; i++) {
          this.$refs.form[i].validate((v)=>{
            if (!v) {
              return;
            }
          });
        }
      }

      return valid;
    },
    handleChangeForm(index, value) {
      this.$set(this.items, index, value);
      this.emitChange();
    },
    initValue() {
      const that = this;
      const _init = debounce(()=>{
        if (that.is_cloned && Array.isArray(that.cloneValues) && (!Array.isArray(that.value) || that.value.length !== that.cloneValues.length)) {
          this.items = that.cloneValues.map((v)=>({[that.config.cloneKey]: v}));
          that.emitChange();
        } else {
          if (Array.isArray(that.value)&& that.value.length > 0) {
            that.items = cloneDeep(that.value);
          } else {
            that.items = [{}];
            that.vid = parseInt(Math.random()*1000);
            that.emitChange();
          }
        }
      }, 250);
      _init();
    },
    handleClick(c, item, index) {
      const model = this.model;
      if (c.control=='Button') {
        this.$set(item, c.to, formatNumber(evil(c.from, {model, item, index})));
      }
    },
    validate() {
      if (this.check_result.state == 'success') {
        return true;
      }
    },
    getError() {
      return this.check_result.message;
    },
    emitChange() {
      this.items.forEach((v, i)=>{
        v.order=(i+1);
        Object.assign(v, this.condition || {});
      });
      this.$emit('input', cloneDeep(this.items));
    },
    generateBindingForm(form){
      const newForm = cloneDeep(form);
      if (form.model_binding && Array.isArray(form.model_binding.data)) {
        const keyMap = {};
        (form.model_binding.data).forEach(binding => {
          if (binding.fieldKey && binding.controlId) {
            keyMap[binding.controlId] = binding.fieldKey;
          }
        });

        function walkFields(fields) {
          if (!Array.isArray(fields)) return fields;
          return fields.map(field => {
            let newField = {...field};
            if (newField.key && keyMap[newField.key]) {
              newField.key = keyMap[newField.key];
            }
            if (Array.isArray(newField.fields)) {
              newField.fields = walkFields(newField.fields);
            }
            return newField;
          });
        }

        if (Array.isArray(newForm.fields)) {
          newForm.fields = walkFields(newForm.fields);
        }
      }

      return newForm;
    },
    getRemoteData() {
      this.loading = true;
      this.$api.afterLogin(()=>{
        this.$store.dispatch('model/load', {id: this.config.model, view: this.view}).then((def)=>{
          this.formDef = def
          this.error = '';
        }).catch((e)=>{
          this.error = e?e.message:'加载错误';
        }).finally(()=>{
          this.loading =false;
        });
      });
    },
    add() {
      this.items.push({});
    },
    copy(i) {
      this.items.splice(i, 0, {...this.items[i], id: undefined});
      this.emitChange();
    },
    remove(i) {
      this.items.splice(i, 1);
      this.emitChange();
    },
  },
};
</script>

  <style lang="scss" scoped>
  </style>
